import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import css from './rule.css';

const Rule = ({ className, rule, inverse, ...props }) => (
  <hr
    className={classnames(className, css['ds-rule'], {
      [css['ds-rule--inverse']]: inverse,
      [css[`ds-rule--${rule}`]]: rule,
    })}
    {...props}
  />
);

Rule.propTypes = {
  className: PropTypes.string,
  rule: PropTypes.oneOf(['emphasised', 'heavy', 'accent']),
  inverse: PropTypes.bool,
};

Rule.defaultProps = {
  className: null,
  rule: null,
  inverse: false,
};

export default Rule;
